import "./App.css";

import { Routes, Route } from "react-router-dom";
import Home from "./Routes.js/Home";
import About from "./Routes.js/About";
import Contact from "./Routes.js/Contact";
import Work from "./Routes.js/Work";
import Projects from "./page/Projects";
import Media from "./page/Media";
import Todo from "./page/Todo";
import SipundPaint from "./page/SipundPaint";
import Miko from "./page/Miko";

function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/work" element={<Work />} />
                <Route path="/work/store-app" element={<Projects />} />
                <Route path="/work/media" element={<Media />} />
                <Route path="/work/todo" element={<Todo />} />
                <Route path="/work/painting" element={<SipundPaint />} />
                <Route path="/work/miko" element={<Miko />} />
            </Routes>
        </div>
    );
}

export default App;
